module.exports = __webpack_public_path__ + "img/30.0ae4e729.png";